/* eslint-disable radix */
/* eslint-disable react/no-danger */
import React, { Component } from 'react';
import { LayoutWithBannerNavbar } from 'layouts';
import ultilitiesService from 'shared/util/ultilitiesService';
import moment from 'moment';
import numeral from 'numeral';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faLongArrowAltLeft } from '@fortawesome/free-solid-svg-icons';
import coin from 'assets/images/coins.svg';
import cashBag from 'assets/images/cash-bags.svg';
import human from 'assets/images/arab-person.svg';
import whiteArrow from 'assets/images/white-bubble-arrow.svg';
import arrowWhite from 'assets/icons/nextWhite.svg';
import { NWDonutChart, BotResponse, BottomButton } from 'components';
import baseUrl from 'shared/util/baseUrl';
import { PATH, WEBSOCKET_STATUS_CONNECTED, ARABIC, COMPONENT_TYPE } from 'shared/constants';
import { FormattedMessage, injectIntl } from 'react-intl';
import { loadState } from 'shared/redux/store/localStorage';
import { connect } from 'react-redux';
import { getRTL } from 'shared/redux/selectors';
import { toggleLanguage, generateChannel, updateInputComponent } from 'shared/redux/actions';
import { getFinancialGoalService } from 'shared/redux/actions/goalSummaryResults';
import iconBigpurchase from 'assets/icons/iconBigpurchase.png';
import iconEducation from 'assets/icons/iconEducation.png';
import iconIncome from 'assets/icons/iconIncome.png';
import iconInvestment from 'assets/icons/iconInvestment.png';
import iconLegacy from 'assets/icons/iconLegacy.png';
import iconRetirement from 'assets/icons/iconRetirement.png';
import classNames from 'classnames';
import Timeline from './Timeline';
import './GoalSummary.scss';
import 'moment/locale/ar';
import { eventGoalSummaryCompleted } from 'components/TrackEvent/constEvent';
import trackEvent from 'components/TrackEvent/TrackEvent';

const statusBarClass = 'status-bar--goal-summary';

class GoalSummary extends Component {
  state = {
    isLoading: true,
  }

  componentDidMount() {
    document.body.classList.add(statusBarClass);

    const {
      history, assetAllocation, onGetFinancialGoalService, intl, onUpdateInputComponent
    } = this.props;

    onUpdateInputComponent(COMPONENT_TYPE.GOAL_SUMMARY);

    if (assetAllocation.length) {
      onGetFinancialGoalService().then(() => this.setState({ isLoading: false }));
    } else {
      history.push(PATH.ASSETS_ALLOCATION);
    }

    if (intl.locale === ARABIC) {
      moment.locale('ar');
    } else {
      moment.locale('en');
    }
  }

  componentWillUnmount() {
    document.body.classList.remove(statusBarClass);
  }

  returnIcon = (goal) => {
    switch (goal) {
      case 'education':
        return iconEducation;
      case 'retirement':
        return iconRetirement;
      case 'investment':
        return iconInvestment;
      case 'big_purchase':
        return iconBigpurchase;
      case 'legacy':
        return iconLegacy;
      case 'income':
        return iconIncome;
      default:
        return null;
    }
  };

  goBack = () => {
    this.props.history.goBack();
  };

  render() {
    const {
      intl, currentLocale, assetAllocation, onGenerateChannel, history, goalSummaryResults,
      isRtl, websocketStatus,
    } = this.props;

    const { isLoading } = this.state;

    const { summary } = loadState();
    const lowInvestment = `${currentLocale === 'EN' ? `${numeral(goalSummaryResults.lowInvestmentValue).format('0,0')} ${goalSummaryResults.currency}` : numeral(goalSummaryResults.lowInvestmentValue).format('0,0')}`;
    const highInvestment = `${currentLocale === 'EN' ? `${numeral(goalSummaryResults.highInvestmentValue).format('0,0')} ${goalSummaryResults.currency}` : numeral(goalSummaryResults.highInvestmentValue).format('0,0')}`;
    const classes = classNames({
      'nw-page-goalSummary': true,
      'nw-page-goalSummary--rtl': isRtl,
    });

    return (
      <LayoutWithBannerNavbar
        // leftButton={<FontAwesomeIcon icon={faLongArrowAltLeft} />}
        leftButton={(<span className="arrow"><img src={arrowWhite} alt="arrow" /></span>)}
        rightButton={ultilitiesService.locale(currentLocale)}
        onRightClick={() => history.push(PATH.LANGUAGE)}
        onLeftClick={this.goBack}
        title="goalSummary.title"
        className={classes}
        isRtl={isRtl}
      >
        <div className="nw-page-goalSummary__goal">
          <div className="nw-page-goalSummary__goal-top">
            <div className="nw-page-goalSummary__goal-icon"><img src={this.returnIcon(summary['summary.goal'])} alt="Icon" /></div>
            <div>
              <h5>{intl.formatMessage({ id: 'summary.selectedGoal' }, { goal: intl.formatMessage({ id: summary['summary.goal'] }) })}</h5>
              <p>{summary['summary.targetAmount']}</p>
              <time>
                {`
                  ${intl.formatMessage({ id: 'goalSummary.from' })}
                  ${moment().format('MMM')} ${moment().format('YYYY')} 
                  ${intl.formatMessage({ id: 'goalSummary.until' })}
                  ${moment().format('MMM')} 
                  ${moment().add(parseInt(summary['summary.targetCompletion']), 'years').format('YYYY')}
                `}
              </time>
            </div>
          </div>
          <div>
            <h5>
              <strong>{`${intl.formatMessage({ id: 'goalSummary.title' })} `}</strong>
              <em>{ intl.formatMessage({ id: 'assetAllocation.recommendedByMarkaz' }) }</em>
            </h5>
            <div className="nw-page-goalSummary__goal-chart" style={{ height: 30 * assetAllocation.length }}>
              <NWDonutChart
                isLegend
                innerRadius={35}
                outerRadius={45}
                // data={chartData}
                data={assetAllocation}
                customLegend={props => (
                  <ul>
                    {props.payload.sort((a, b) => (b.payload.value - a.payload.value)).map((i, idx) => (
                      <li key={idx}>
                        <div>
                          <svg
                            className="recharts-surface"
                            width="8"
                            height="8"
                            viewBox="0 0 32 32"
                            style={{ display: 'inline-block', verticalAlign: 'middle', marginRight: '4px' }}
                          >
                            <path
                              fill={i.payload.color}
                              className="recharts-symbols"
                              transform="translate(16, 16)"
                              d="M16,0A16,16,0,1,1,-16,0A16,16,0,1,1,16,0"
                            />
                          </svg>
                          <span className="recharts-legend-item-text">{intl.formatMessage({ id: i.payload.code })}</span>
                        </div>
                        <span>{`${i.payload.value} %`}</span>
                      </li>
                    ))}
                  </ul>
                )}
                legendWidth="70%"
              />
            </div>
          </div>
          <div className="nw-page-goalSummary__goal-bottom">
            <p>
              <FormattedMessage
                id="risk.youAre"
                values={{ risk: summary && <b>{intl.formatMessage({ id: summary['summary.risk'] })}</b> }}
              />
            </p>
            {summary && <img src={`${baseUrl}/images/small-${summary['summary.risk']}.svg`} alt={summary['summary.risk']} />}
          </div>
        </div>
        <div className="nw-page-goalSummary__investment">
          <ul>
            <li>
              <FormattedMessage id="summary.initialInvestment" />
              <span>{summary['summary.initialInvestment']}</span>
            </li>
            <li>
              <FormattedMessage id="summary.annualInvestment" />
              <span>{summary['summary.annualInvestment']}</span>
            </li>
          </ul>
          <div>
            <p>
              <FormattedMessage id="goalSummary.initialInvestmentOf" />
              <br />
              <b>{summary['summary.initialInvestment']}</b>
            </p>
            <div className="nw-page-goalSummary__investment-timeline">
              <img className="coin" src={coin} alt="Coin" />
              <img className="cash-bag" src={cashBag} alt="Cash" />
              <img className="human" src={human} alt="Human" />
              <Timeline data={[
                {
                  time: moment().format('YYYY'),
                },
                {
                  time: moment().add(parseInt(summary['summary.targetCompletion']), 'years').format('YYYY'),
                },
              ]}
              />
            </div>

            <div className="nw-page-goalSummary__investment-response">
              {!isLoading ? (
                <article dangerouslySetInnerHTML={{
                  __html: `
                  ${`
                  ${intl.formatMessage({ id: 'goalSummary.summary' }, { low: lowInvestment, high: highInvestment, year: goalSummaryResults.period })} 
                  ${intl.formatMessage({ id: goalSummaryResults.messageResultTextEn })}
                  `}`,
                }}
                />
              ) : <></>}
              {/* <div dangerouslySetInnerHTML={{ __html: intl.formatMessage({ id: 'goalSummary.summary' }) }} className="hidden" /> */}
              <img src={whiteArrow} alt="Arrow" />
            </div>

            <BotResponse rtl={isRtl} message="goalSummary.botResponse" />
          </div>
        </div>
        <BottomButton
          value={intl.formatMessage({ id: 'goalSummary.continue' })}
          onButtonClick={() => {
            onGenerateChannel();
            history.push(PATH.CALL_TO_ACTION);
            trackEvent(eventGoalSummaryCompleted(currentLocale, intl.formatMessage({ id: 'goalSummary.continue' })));
          }}
          isOutlineButton
          isDisabled={websocketStatus !== WEBSOCKET_STATUS_CONNECTED}
        />
      </LayoutWithBannerNavbar>
    );
  }
}

const mapStateToProps = state => ({
  currentLocale: state.rootReducer.language.locale,
  assetAllocation: state.assetAllocations.assetAllocation,
  goalSummaryResults: state.goalSummaryResults,
  websocketStatus: state.rootReducer.websocketStatus,
  isRtl: getRTL(state.rootReducer),
});

const mapDispatchToProps = ({
  onSwitchLanguage: toggleLanguage,
  onGenerateChannel: generateChannel,
  onGetFinancialGoalService: getFinancialGoalService,
  onUpdateInputComponent: inputComponent => updateInputComponent(inputComponent),
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(GoalSummary));
